import { IonButtons, IonTitle, IonToolbar } from '@ionic/react';
import { IonHeader } from '@ionic/react';
import { FC } from 'react';
import ProfileIcon from '../../assets/icons/ProfileIcon';
import { Modals } from '../../exports/Enums';
import useModalRouter from '../../common/hooks/useModalRouter';
import useRouter from '../../../../hooks/navigation/useRouter';
import ChevronLeftIcon from '../../assets/icons/ChevronLeftIcon';
import Button from '../../components/buttons/Button';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  onBackClick?: () => void;
  hasBackButton?: boolean;
}

const PageHeader: FC<Props> = ({ title, onBackClick, hasBackButton = true }): JSX.Element => {
  const { openModal } = useModalRouter();
  const { goBack } = useRouter();
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Components:Headers:PageHeader' });

  return (
    <IonHeader>
      <IonToolbar
        style={{
          '--background': 'white',
          '--padding-top': '10px',
          '--padding-bottom': '10px',
          '--padding-start': '16px',
          '--padding-end': '16px',
        }}
      >
        {hasBackButton && (
          <IonButtons slot="start">
            <Button design="link" onClick={() => (onBackClick ? onBackClick() : goBack())}>
              <>
                <ChevronLeftIcon className="stroke-brand-primary h-[14px] w-[10px] mr-xs" />
                <span className="text-brand-primary font-semibold text-base">{t('buttons.back')}</span>
              </>
            </Button>
          </IonButtons>
        )}
        <IonButtons slot="end" onClick={() => openModal({ id: Modals.Profile })}>
          <ProfileIcon className="stroke-black size-6" />
        </IonButtons>
        <IonTitle>{title}</IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};

export default PageHeader;
